export default __webpack_public_path__ + "./assets/about-logo__14c488e02d246d5da501b15d8e63b761.png";